import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSlidesTallAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M4 18V2H16V6H20V22H8V18H4ZM14.5 3.5V6H8V16.5H5.5V3.5H14.5ZM14.75 11H13.25V13.25H11V14.75H13.25V17H14.75V14.75H17V13.25H14.75V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesTallAdd;
